import React from 'react'
import { ModalWindow } from '../../GeneralComponents/ModalWindow/ModalWindow'
import { ButtonOutline } from '../../GeneralComponents/ButtonOutline/ButtonOutline'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export function BackdropModal({ isOpenModal, setIsOpenModal, onSubmit }) {
  return (
    <ModalWindow
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false)
      }}
    >
      <div className={classes.wrapper}>
        <div>
          <h2 className={classes.title}>Ready to Post Your Backdrop?</h2>
          <h6 className={classes.subTitle}>
            Before you publish, let’s confirm a few things.
          </h6>
          <p className={classes.text}>
            To respect the rights of all artists and rights holders, any Backdrop 
            you make live will be treated as active content on the Feels platform. 
            By choosing to post this content, you confirm that you hold the necessary
             rights to do so.
          </p>
          <p className={classes.text}>
            You represent and warrant that you have all required rights — including 
            the rights to stream, enable offline access, and publicly display the 
            Backdrop to Feels users. This includes pairing it with other media  
            (such as audio or lyrics) within the platform.
          </p>
          <p className={classes.text}>
            You also acknowledge that your Backdrop will be publicly available in 
            the Feels app for users to view and engage with.
          </p>
          <p className={classes.text}>
            Please confirm that you have the appropriate rights to publish this content.
          </p>
        </div>
        <div className={classes.buttonWrapper}>
          <ButtonOutline
            disable={false}
            onClick={() => {
              onSubmit()
            }}
            fontFamily="Noto Sans"
            fontWeight={700}
            text={'CONFIRM & POST BACKDROP'}
            color={'pink'}
          />
        </div>
      </div>
    </ModalWindow>
  )
}

BackdropModal.propTypes = {
  isOpenModal: PropTypes.bool,
  setIsOpenModal: PropTypes.func,
  onSubmit: PropTypes.func,
}
